import styled from 'styled-components';
import {
  NavigationAndActionFailSmall,
  NavigationAndActionSuccessSmall,
  NavigationAndActionTime,
  NavigationAndActionWarningSmall,
} from '../ui/icons';
import { setIconColor } from './cssUtils';
import { Label, Subtitle, theme } from '../ui';

export const TableCellWithIcon = styled.span`
  display: flex;
  align-items: center;
  svg {
    height: 1rem;
    width: 1rem;
    margin-right: 0.6rem;
  }
`;
export const ActiveIcon = styled(NavigationAndActionSuccessSmall)`
  ${setIconColor(theme.colors.primaryG5)}
`;
export const ExpiringIcon = styled(NavigationAndActionWarningSmall)`
  ${setIconColor(theme.colors.primaryO5)}
`;
export const TerminatedIcon = styled(NavigationAndActionFailSmall)`
  ${setIconColor(theme.colors.primaryR5)}
`;
export const ExpiredIcon = styled(NavigationAndActionTime)`
  ${setIconColor(theme.colors.primaryB1)}
`;
export const StyledLabel = styled(Label)`
  margin-bottom: 0;
`;
export const StyledSubtitle = styled(Subtitle)`
  margin-bottom: 0;
  line-height: 1.375rem;
`;
export const ExpiryWrapper = styled.span<{ accented: boolean }>`
  color: ${(props) => (props.accented ? theme.colors.primaryR1 : 'intial')};
`;
